import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";
import {findFingertip} from "../../../utils/awsAmplifyUtil";
import {Dict} from "../../../types/pj1dbApi";
import {FingertipDocument} from "../../equipmentdb/types/pj1dbApiFingertip";

export interface UseFingertipParams {
  onChange: (newData: Dict<FingertipDocument>[], newStatus: Status) => void;
  enableAutoFetch?: boolean;
  initialStatus?: Status;
  fingertipIds?: string[];
}

export function useFingertip(params: UseFingertipParams) {
  const result = useFetchAllQuery({
    queryFn: () => findFingertip({
      "query": {
        "fingertipId": {
          "$in": params.fingertipIds ?? []
        }
      }
    }),
    needToFetchMore: () => false,
    enableAutoFetch: params.enableAutoFetch,
  })
  const helper = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data,
    status: result.status,
    initialStatus: params.initialStatus,
  });

  return {
    ...result,
    ...helper,
  };
}
